export enum ReferenceLookupType {
  None = 0,
  SpecialLookupSql = 1,
  ShowExisting = 2
}